import { combineReducers } from 'redux'

import app from '../app/app_reducer'
import account from '../ui/account/account_reducer'
import impostazioni from '../ui/impostazioni/impostazioni_reducer'

// import gruppoProdotto from '../ui/gruppoProdotto/gruppoProdotto_reducer'
import microCategorie from '../ui/microCategorie/microCategorieReducer'
import prodotto from '../ui/prodotto/prodotto_reducer'
import garanzie from '../ui/garanzie/garanzie_reducer'
import bisogni from '../ui/bisogni/bisogni_reducer'
import testReducer from "../ui/test/testReducer"
import localizzazione from '../ui/localizzazione/i18n_reducer'
import famiglieProdotto from '../ui/famigliaProdotto/famiglieProdottoReducer'
import categorieProdotto from '../ui/categorieProdotto/categorieProdottoReducer'
import compagnie from '../ui/compagnie/compagnieReducer'
import fondi from '../ui/fondi/fondi_reducer'

const appReducers = combineReducers({
  app,
  account,
  impostazioni,
  // gruppoProdotto,
  microCategorie,
  prodotto,
  garanzie,
  testReducer,
  localizzazione,
  bisogni,
  famiglieProdotto,
  categorieProdotto,
  compagnie,
  fondi,
});

export default appReducers;